import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { videosList_template } from "../components/templates/videosList_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class videos extends vnModule_knockoutJS {
    protected listTemplate: videosList_template;
    protected pagination: pagination_template;
    protected timer: number;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected viewPageUrl;

    protected getModuleName() {
        return "videos";
    }

    public buildContent(): Array<Element> {
        this.listTemplate = new videosList_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Videos List");

        return [this.listTemplate.build()];
    }

    public fillPage(): void {
        this.listTemplate.buildDatePickerCalendar();
        this.getVideoReferences();
        //this.getData();
    }

    protected getVideoReferences() {
        //this.loadingIn(this.listTemplate.builtTemplate);
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/references";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetVideoReferences;
        this.XHRHdl.execute();
    }

    protected onGetVideoReferences(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                //console.log(responseParsed);
                obj.listTemplate.setContentTypeFilter(responseParsed.contentTypes);
                obj.listTemplate.setCategoryFilter(responseParsed.categories);
                obj.listTemplate.setUploadSourceFilter(responseParsed.uploadSources, responseParsed.selectedUploadSource);
                obj.getData();
            });
        };
    }

    protected getData() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList() {
        this.filterSimpleCancel();
        this.loadingIn(this.listTemplate.builtTemplate.children.namedItem("list-results"));
        this.timer = new Date().getTime();
        this.sendFilterCall(
            "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/get/",
            this.listTemplate.getViewModelForRequest(),
            this.onFilterList,
            XMLHttpRequestHandler_requestType.GET,
            "videos",
            this.listTemplate.builtTemplate.children.namedItem("list-results"),
        );
    }

    protected onFilterList(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                //console.log(responseParsed);
                let videosToSet = [];
                for (let item of responseParsed.paginatedVideos.data) {
                    let producer =
                        item.details !== null && item.details.producer !== null ? item.details.producer : null;
                    let producerFullName =
                        producer !== null &&
                        producer.valnet_user !== null &&
                        producer.valnet_user.fullNameAndLogin !== null
                            ? producer.valnet_user.fullNameAndLogin
                            : null;

                    if (item.videoSubtitles && item.videoSubtitles.length > 0) {
                        let isProcessing = item.videoSubtitles[0].url == "auto-generated" ? true : false;
                        let isAutoGenerated = item.videoSubtitles[0].isAutoGenerated == 1 ? true : false;
                        item.subtitleStatus = isProcessing ? "Processing" : isAutoGenerated ? "Auto-generated" : "Manual";
                    } else {
                        item.subtitleStatus = "None";
                    }

                    let idArticle = (item.details && item.details.idArticle) ? item.details.idArticle : null;
                    let articleTitle = (item.details && item.details.articleTitle) ? item.details.articleTitle : null;
                    videosToSet.push({
                        id: item.id,
                        thumbnail: item.thumbnail.url,
                        title: item.title,
                        url: item.url,
                        producer: producerFullName,
                        subtitleStatus: item.subtitleStatus,
                        dateCreated: item.dateCreated,
                        dateUpdated: item.dateUpdated,
                        idArticle: idArticle,
                        //articleTitle check if item details exists and item details article exists and set the title from it article details title
                        articleTitle: articleTitle,

                    });
                }
                obj.listTemplate.setIdBrand(obj.getVnAppZone().app.params.idBrand);
                obj.listTemplate.setVideos(videosToSet);
                obj.listTemplate.setResultInfo(
                    responseParsed.paginatedVideos.totalCount,
                    responseParsed.paginatedVideos.totalPage,
                    Math.round(((new Date().getTime() - obj.timer) / 1000) * 100) / 100,
                );
                obj.viewModel.list.pagination.itemCount(responseParsed.paginatedVideos.totalCount);
                obj.updateViewModelFromPath();
                obj.getSearchPresets();
            });
            obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected filterByUrl() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters) {
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected filterDateOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(idElement) {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected videosListReorder() {
        this.filterList();
    }

    protected getUsersSuggestion(keyword, idElement) {
        this.cancelRequest("getUsersSuggestion");
        let subViewModel = { list: { keyword: keyword }, idElement: idElement };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getUsersSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getUsersSuggestion"].onReadyStateFunction = this.onGetUsersSuggestions;
        this.XHRHdls["getUsersSuggestion"].execute();
    }

    protected onGetUsersSuggestions(req, obj) {
        return function () {
            if (req.request.readyState == 4) {
                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.users) {
                        if (responseParsed.data.idElement == "producerFilter") {
                            obj.listTemplate.setProducerFilter(responseParsed.data.users);
                        }
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_WARNING,
                        responseParsed.message,
                    );
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.listTemplate.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.listTemplate.deactivateLoading();
            }
        };
    }

    protected getMemoryViewModel() {
        let templateViewModel = this.listTemplate.getTemplateViewModel();
        delete templateViewModel.videos;
        return templateViewModel;
    }

    protected addVideo() {
        this.filterSimpleCancel();
        this.saveViewModule(this.getMemoryViewModel());
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/add");
    }

    protected viewVideo(id) {
        this.saveViewModule(this.getMemoryViewModel());
        let viewUrl =
            window.location.origin + "/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/view/" + id;
        let editUrl =
            window.location.origin + "/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/edit/" + id;
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/view/" + id);
    }

    protected getSearchPresets(): void {
        this.cancelRequest("getSearchPresets");
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_url: string = "/api/search_preset/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getSearchPresets"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getSearchPresets"].onReadyStateFunction = this.onGetSearchPresets;
        this.XHRHdls["getSearchPresets"].execute();
    }

    protected onGetSearchPresets(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
                //obj.filterList();
            });
        };
    }

    protected saveSearchPreset() {
        this.cancelRequest("saveSearchPreset");
        let formReq_url: string = "/api/search_preset/save";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveSearchPreset"] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls["saveSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveSearchPreset"].onReadyStateFunction = this.onSaveSearchPreset;
        this.XHRHdls["saveSearchPreset"].execute();
    }

    private onSaveSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected saveFavoriteSearchPreset(params: { presetId: number; searchPresetType: string }): void {
        this.cancelRequest("saveFavoriteSearchPreset");
        let formReq_url: string = "/api/search_preset/favorite/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(params));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveFavoriteSearchPreset"] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdls["saveFavoriteSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveFavoriteSearchPreset"].onReadyStateFunction = this.onSaveFavoriteSearchPreset;
        this.XHRHdls["saveFavoriteSearchPreset"].execute();
    }

    private onSaveFavoriteSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected deleteSearchPreset(presetId: number): void {
        this.cancelRequest("deleteSearchPreset");
        let usrReq_url: string = "/api/search_preset/delete/" + presetId + "/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["deleteSearchPreset"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["deleteSearchPreset"].onReadyStateFunction = this.onDeleteSearchPreset;
        this.XHRHdls["deleteSearchPreset"].execute();
    }

    protected onDeleteSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected setDefaultStatusFilters() {}

    protected getTagsSuggestion(keyword, idElement) {
        this.cancelRequest("getTagsSuggestion");
        let subViewModel = { filter: { keyword: keyword }, idElement: idElement };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls["getTagsSuggestion"].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;
                    obj.listTemplate.setTagFilter(responseParsed.data.tags);
                }
            });
        };
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    public generateVideoArticle(data, videoArticleId) {

        let link : string  = "/brand/" + this.getVnAppZone().app.params.idBrand 
        if(videoArticleId){
            link += "/articles/view/" + videoArticleId;
        } else {
            link += "/articles/add?videoId=" + data.id;
        }
        // Open the URL in a new tab
        window.open(link, '_blank');
    }
}



// WEBPACK FOOTER //
// ./js/modules/videos.ts